import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-transform}
 */
export default Longhand.fromKeywords({ inherits: true }, "none", "capitalize", "uppercase", "lowercase");
//# sourceMappingURL=text-transform.js.map